<mat-form-field floatLabel="auto" appearance="outline" class="w-100 bdg-date-field">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [matDatepicker]="dp"
    [formControl]="control"
    autocomplete="off"
    placeholder="mm/aaaa"
    (blur)="onDateInput($event.target.value)"
    [errorStateMatcher]="matcher"
    [readonly]="readonly"
  />
  <mat-datepicker-toggle [class.mat-error]="error()" matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    startView="multi-year"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, dp)"
    panelClass="example-month-picker"
  >
  </mat-datepicker>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="error()">{{ error() }}</mat-error>
</mat-form-field>
